// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ee2df005","124":"f024d470","158":"b4c16cc4","453":"888061ae","472":"3da4e5bf","484":"d4d5a90d","536":"483a2c84","560":"e548bf17","715":"cb84fff8","717":"b2b490cc","750":"990c5f60","920":"393d1835"}[chunkId] + ".chunk.js";
};